<div *ngIf="!completed" class="title-challenge">Get started on:</div>
<div *ngIf="completed" class="title-challenge-complete">Congrats for completing:</div>
